import { Component } from '@angular/core';

@Component({
    selector: 'scroll-container',
    templateUrl: 'scroll-container.template.html',
    styleUrls: ['scroll-container.less']
})
export class ScrollContainerComponent {
    AllComponents = ['homepage', 'info1', 'line-up1', 'line-up2', 'info2', 'box-office-wrapper', 'partner'];
}